import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';

export function exportToExcel<T extends object>(
  data: T[],
  filename: string,
  sheetName: string = 'Données'
): void {
  const ws = XLSX.utils.json_to_sheet(data as Record<string, unknown>[]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${filename}.xlsx`);
}

export function exportToPDF(
  title: string,
  headers: string[],
  rows: string[][],
  filename: string
): void {
  const doc = new jsPDF({ orientation: 'landscape' });

  doc.setFontSize(16);
  doc.text(title, 14, 20);

  doc.setFontSize(8);
  doc.text(`Export du ${new Date().toLocaleDateString('fr-FR')}`, 14, 28);

  const startY = 36;
  const cellPadding = 4;
  const colWidth = (doc.internal.pageSize.getWidth() - 28) / headers.length;
  let y = startY;

  // Headers
  doc.setFillColor(37, 99, 235);
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(8);
  headers.forEach((header, i) => {
    doc.rect(14 + i * colWidth, y, colWidth, 10, 'F');
    doc.text(header, 14 + i * colWidth + cellPadding, y + 7);
  });
  y += 10;

  // Rows
  doc.setTextColor(30, 30, 30);
  rows.forEach((row, rowIndex) => {
    if (y > doc.internal.pageSize.getHeight() - 20) {
      doc.addPage();
      y = 20;
    }
    if (rowIndex % 2 === 0) {
      doc.setFillColor(245, 245, 245);
      doc.rect(14, y, colWidth * headers.length, 8, 'F');
    }
    row.forEach((cell, i) => {
      const text = String(cell || '').substring(0, 30);
      doc.text(text, 14 + i * colWidth + cellPadding, y + 6);
    });
    y += 8;
  });

  doc.save(`${filename}.pdf`);
}
